const topicItems = [
  { name: '#某顶流塌房', heat: '1.2亿阅读', size: 'large' },
  { name: '#直播带货翻车', heat: '9865万阅读', size: 'large' },
  { name: '#网红人设造假', heat: '8742万阅读', size: 'small' },
  { name: '#粉丝站集体关站', heat: '7653万阅读', size: 'large' },
  { name: '#MCN合同陷阱', heat: '6541万阅读', size: 'small' },
  { name: '#电竞假赛风暴', heat: '5432万阅读', size: 'small' },
  { name: '#知识付费割韭菜', heat: '4876万阅读', size: 'large' },
  { name: '#海外网红塌房', heat: '3654万阅读', size: 'small' },
  { name: '#娱乐圈年度大瓜', heat: '1.5亿阅读', size: 'large' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-50 text-center mb-14">
          话题标签：全网热议关键词
        </h2>

        <div className="flex flex-wrap justify-center gap-4">
          {topicItems.map((item, idx) =>
            item.size === 'large' ? (
              <span
                key={idx}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300/30 text-foreground-100 text-sm font-medium hover:border-accent-500 hover:text-accent-500 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.name}
                <span className="text-xs text-foreground-500">{item.heat}</span>
              </span>
            ) : (
              <span
                key={idx}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500 text-background-950 text-sm font-bold hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.name}
                <span className="text-xs opacity-70">{item.heat}</span>
              </span>
            ),
          )}
        </div>
      </div>
    </section>
  );
}